export const fileState = {
    RUNNING: 0,
    SUSPENDED: 1,
    IN_OPTION: 2,
    IN_RESERVATION: 3,
    OPTION_RESERV: 4,
    CONFIRMED: 5,
    SOLD: 6,
    NOT_SOLD: 7,
    PART_SOLD: 8,
    CANCELED: 9,
    ABANDONED: 10,
    TECH_ERROR: 11
};
